import useQueryParamData from '@/components/hooks/useQueryParamData';
import { useSeoMfeSharedData } from '@/components/hooks/useSeoMfeSharedData';
import OverlaySpinner from '@/components/OverlaySpinner';
import useIsHkRedesign from '@/components/hooks/useIsHkRedesign';
import { useHideEnrollmentSteps } from '@/components/hooks/useHideEnrollmentSteps';
import { useAppDispatch, useSeekerState } from '@/components/AppState';
import HousekeeperWhatPage from '@/components/pages/seeker/hk/housekeeper-what/housekeeper-what';
import HousekeepingCleaningTypePage from '@/components/pages/seeker/hk/housekeeping-cleaning-type/housekeeping-cleaning-type';
import { YesOrNoAnswer } from '@/__generated__/globalTypes';
import HousekeepingDatePage from '@/pages/seeker/hk/care-date';
import withFlowStartPoint from '@/utilities/withFlowStartPoint';
import { useEffect } from 'react';
import { AnalyticsHelper } from '@/utilities/analyticsHelper';
import { CLIENT_FEATURE_FLAGS, FLOWS } from '@/constants';

function HousekeepingIndex() {
  const dispatch = useAppDispatch();
  const { isFetching: isFetchingSeoMfeData } = useSeoMfeSharedData();
  useQueryParamData();
  const { isUserEligibleForTest } = useHideEnrollmentSteps();
  const { isUserAssignedToSkipSteps, queryParamMetadata } = useSeekerState();
  const { isHkRedesign, isHkRedesignM2, hkEnrollmentPAJDay1Flag } = useIsHkRedesign();

  useEffect(() => {
    AnalyticsHelper.logTestExposure(
      CLIENT_FEATURE_FLAGS.GROWTH_HK_ENROLLMENT_PAJ_DAY1,
      hkEnrollmentPAJDay1Flag
    );
  }, []);

  useEffect(() => {
    if (isHkRedesign || isHkRedesignM2) {
      dispatch({ type: 'setFlowName', flowName: FLOWS.SEEKER_HOUSEKEEPING_REDESIGN.name });
      dispatch({ type: 'setIsHkRedesign', isHkRedesign });
      dispatch({ type: 'setIsHkRedesignM2', isHkRedesignM2 });
    }
  }, [isHkRedesign, isHkRedesignM2]);

  if (
    isFetchingSeoMfeData ||
    isUserEligibleForTest === undefined ||
    (isUserEligibleForTest && isUserAssignedToSkipSteps === undefined)
  ) {
    return <OverlaySpinner isOpen wrapped />;
  }
  // if intent (care date) supplied, then skip the next page
  const skipCareDateStep =
    isUserAssignedToSkipSteps === YesOrNoAnswer.YES && queryParamMetadata?.intentSupplied;

  if (isHkRedesign || isHkRedesignM2) {
    return <HousekeepingCleaningTypePage />;
  }
  if (skipCareDateStep) {
    return <HousekeeperWhatPage />;
  }
  return <HousekeepingDatePage />;
}

export default withFlowStartPoint(HousekeepingIndex);
